import React, { useState } from 'react';
import './FaqSection.css';

const FAQS = [
  {
    question: 'How is this different from LinkedIn or other job portals?',
    answer:
      'Unlike traditional job platforms, we focus on making you job-ready. We combine skill-based learning, personalized CV building, and AI-powered job matching so you stand out to recruiters.',
  },
  {
    question: 'Who can join?',
    answer:
      'Students, fresh graduates, and professionals looking to upskill or switch careers can all benefit from our platform.',
  },
  {
    question: 'Do I need coding experience to start?',
    answer:
      'Not at all! We offer structured roadmaps for beginners as well as advanced learners.',
  },
  {
    question: 'What kind of courses are available?',
    answer:
      'We cover in-demand fields like Artificial Intelligence, Machine Learning, Data Science, Cloud Computing, Cybersecurity, Digital Marketing, and more.',
  },
  {
    question: 'How does CV building work?',
    answer:
      'Our AI-powered CV builder creates ATS-friendly resumes that highlight your strengths and boost your chances of getting shortlisted.',
  },
  {
    question: 'Will you also help me get a job?',
    answer:
      'Yes! We connect learners with industry partners, recruiters, and real-time opportunities. Plus, we provide mock interviews and career mentorship.',
  },
  {
    question: 'Is there a free plan?',
    answer:
      'Yes, you can explore basic features for free. Premium plans unlock advanced courses, personalized CV support, and priority job connections.',
  },
  {
    question: 'How do I get started?',
    answer:
      'Just sign up with your email, pick a learning path, and start building your skills and career profile instantly.',
  },
  {
    question: 'Do you offer career support beyond jobs?',
    answer:
      'Yes. We provide mentorship, networking opportunities, and resources to help you grow continuously in your career.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="faq-section">
      <h2 className="faq-title">FAQ’s</h2>
      <div className="faq-list">
        {FAQS.map((faq, idx) => (
          <div
            key={idx}
            className={`faq-item${openIndex === idx ? ' open' : ''}`}
            onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
            tabIndex={0}
            role="button"
            aria-expanded={openIndex === idx}
          >
            <div className="faq-question">
              {faq.question}
              <span className="faq-toggle">{openIndex === idx ? '−' : '+'}</span>
            </div>
            <div
              className="faq-answer"
              style={{
                maxHeight: openIndex === idx ? '100px' : '0px',
                opacity: openIndex === idx ? 1 : 0,
              }}
            >
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
